import { adminClient, organizationClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export function createClient(baseURL?: string) {
  return createAuthClient({
    baseURL: baseURL ?? '',
    plugins: [organizationClient(), adminClient()],
  });
}

export type AuthClient = ReturnType<typeof createClient>;
